<div class="grid grid-nogutter p-fluid">
    @if (isBrowser && activityList().length > 0) {
        <div class="col-12">
            <p-carousel [value]="activityListSlideSHow()" [numVisible]="1" [numScroll]="1" [circular]="true">
                <ng-template let-menu pTemplate="item">
                    <!--div #container class="border-round m-2 p-2" style="border: 1px solid var(--surface-d)"
                         [ngStyle]="{height: '540px', width: '100%', position: 'relative', backgroundImage: 'url(https://booking4k.unideb.hu/rest/booking/displayDocument' + '/id/' + menu.slideshowImage,
                         backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat'}"-->
                    <div class="border-round m-2 p-2 slideshow-container" style="border: 1px solid var(--surface-d)" [ngStyle]="{width: '100%', position: 'relative'}">
                        <img [ngSrc]="environment.documentDisplayUrl + '/id/' + menu.slideshowImage"
                             alt="" fill style="object-fit: cover" priority>
                        <div class="flex flex-column justify-content-end" [ngStyle]="{height: '90%'}">
                            <div class="grid bg-white-alpha-90 align-content-center slideshow-button-container" [ngStyle]="{width: '350px', padding: '24px 32px', zIndex: 1}">
                                <h3 class="col-12 my-0 py-0">{{menu.name}}</h3>
                                <div class="col-12">
                                    <button pButton [label]="'Jelentkezés az eseményre'" icon="pi pi-arrow-right" iconPos="right"
                                            (click)="activityBannerClicked(menu)"></button>
                                </div>
                            </div>
                            <div class="grid bg-white-alpha-90 align-content-center slideshow-button-container-mobile" [ngStyle]="{width: '75%', zIndex: 1}">
                                <div class="col-12 m-2 font-bold overflow-hidden text-overflow-ellipsis">{{menu.name}}</div>
                                <div class="col-12">
                                    <button pButton [label]="'Jelentkezés'"
                                            (click)="activityBannerClicked(menu)"></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </p-carousel>
        </div>
    }  @else {
        <div class="col-12">
            <p-skeleton class="my-skeleton" animation="wave" width="100%" height="589px" />
        </div>
    }

    <div class="col-12 flex justify-content-center my-5">
        <div class="grid px-4 lg:px-8 center" [ngStyle]="{maxWidth: '1400px'}">
            @for (details of buttonDetails; track $index) {
                <ng-container [ngTemplateOutlet]="blockButton" [ngTemplateOutletContext]="{buttonDetail: details}"></ng-container>
            }
        </div>
    </div>

    <!--div class="col-12 flex justify-content-center">
        <router-outlet></router-outlet>
    </div-->

    <div class="col-12 flex justify-content-center">
        @switch (view) {
            @case ('main') {
                <div></div>
            }
            @case ('activitySearcher') {
                <ng-container [ngTemplateOutlet]="activitySearcher"></ng-container>
            }
            @case ('fulfillmentList') {
                <div class="grid col-12 flex justify-content-evenly px-4 lg:px-8 center" [ngStyle]="{maxWidth: '1400px'}">
                    <app-fulfillment-list class="col-12" [selectedOption]="selectedTableView"></app-fulfillment-list>

                </div>
            }
            @case ('calendar') {
                <div class="grid col-12 flex justify-content-evenly px-0 lg:px-8 center" [ngStyle]="{maxWidth: '1400px'}">
                    <h1 class="col-12">Esemény naptár</h1>
                    <app-event-calendar class="col-12" (eventSelectionEmitter)="eventSelected($event)"></app-event-calendar>

                </div>
            }
        }
    </div>
</div>

<abydos-form-dialog #eventDataDialog [newDialogTitle]="'Választott esemény részletei | ' + (selectedEvent ? selectedEvent.title : selectedActivity?.name)"
    [ngStyle]="{width: '80vw'}">
    <ng-template abydosDialogBody let-dialog="dialog">
        <app-application-edited-data [selectedActivity]="selectedActivity" [dialog]="dialog"
                               [applicationView]="false" [selectedEvent]="selectedEvent" (formSaved)="editedDataSaved($event)"></app-application-edited-data>
    </ng-template>
</abydos-form-dialog>

<ng-template #blockButton let-buttonDetail="buttonDetail">
    <div class=" col-12 lg:col-3 md:col-6 p-4" (click)="buttonDetail.action()">
        <div class="p-4 card-button cursor-pointer"
             [ngStyle]="{ 'background-color': buttonDetail?.backgroundColor, height: '100%'}">
            <div class="text-xl mb-2">
                <i class="text-2xl font-bold" [ngClass]="buttonDetail?.icon"></i>
            </div>
            <div class="font-bold text-lg">{{ buttonDetail?.title }}</div>
            <p>{{ buttonDetail?.text }}</p>
        </div>
    </div>
</ng-template>

<ng-template #activitySearcher>
    <div class="grid flex justify-content-evenly px-4 lg:px-8 center" [ngStyle]="{maxWidth: '1400px', width: '100%'}">
        <h1 class="col-12">Tevékenység kereső</h1>
        <app-activity-searcher class="col-12" (activitySelectionEmitter)="activitySelected($event)"></app-activity-searcher>
    </div>
</ng-template>

<p-confirmDialog />

